import { useTranslation } from '@ecomm/i18n'
import { useBusiness } from '@ecomm/smb-components/BusinessProvider/BusinessProvider'

export function AvailableTime() {
  const { isBusiness } = useBusiness()
  const { t } = useTranslation('header')

  return (
    <div className="flex items-center mt-2">
      <div className="h-2 w-2 bg-complementary-sage-100 border-solid border border-gray-800 rounded" />
      <span className="ml-1 text-sm font-normal opacity-90 max-[1126px]:text-xs">
        {isBusiness
          ? t('call-specialist-dropdown-menu.business-available-time')
          : t('call-specialist-dropdown-menu.available-time')}
      </span>
    </div>
  )
}
